// extracted by mini-css-extract-plugin
export default {"image":"image_image__mbQGi","image-area":"image_image-area__K78YR","icon":"image_icon__GyVgb","info":"image_info__NYyXV","inputs":"image_inputs__7nYlf"};